<template>
	<div class="recharge_wrap">
		<div class="title-box">
			<button class="back" @click="$router.go(-1)">
				<i class="iconfont icon-zuojiantou2"></i>
			</button>
			<h2>{{ $t('account.addAccount') }}</h2>
		</div>
		<div class="wrap_box warp1">
			<div class="item">
				<div class="ari_font">{{ $t('account.bank') }}：</div>
				<van-dropdown-menu>
					<van-dropdown-item v-model="value" :options="wallets" @change="onChange()" :disabled="id !== -1"/>
				</van-dropdown-menu>
			</div>
			<!-- 虚拟货币 -->
			<div v-show="type == 1">
				<div class="item">
					<div class="ari_font">{{ $t('account.address') }}：</div>
					<input class="card" type="text" v-model="bank.account" :placeholder="$t('account.addressTit')">
				</div>
				<div class="qrcode">
					<div>{{ $t('account.qrcodetips') }}</div>
					<div class="qrcode_img">
						<!-- <span>QR code</span> -->
						<van-uploader v-model="fileList" multiple :max-count="1" class="upload"
							:max-size="2 * 1024 * 1024" @oversize="onOversize" :after-read="afterRead"
							:before-read="beforeRead">
						</van-uploader>
					</div>
				</div>
			</div>
			<!-- 支付宝 -->
			<div v-show="type == 2">
				<div class="item">
					<div class="ari_font">{{ $t('accountUsdt.alipayAccount') }}</div>
					<input class="card" type="text" v-model="bank.account"
						:placeholder="$t('accountUsdt.alipayAccountEmpty')">
				</div>
				<div class="qrcode">
					<div>{{ $t('accountUsdt.alipayQrcode') }}</div>
					<div class="qrcode_img">
						<van-uploader v-model="fileList" multiple :max-count="1" class="upload"
							:max-size="2 * 1024 * 1024" @oversize="onOversize" :after-read="afterRead"
							:before-read="beforeRead">
						</van-uploader>
					</div>
				</div>
			</div>
			<!-- 微信 -->
			<div v-show="type == 3">
				<div class="item">
					<div class="ari_font">{{ $t('accountUsdt.wechatAccount') }}</div>
					<input class="card" type="text" v-model="bank.account"
						:placeholder="$t('accountUsdt.wechatAccountEmpty')">
				</div>
				<div class="qrcode">
					<div>{{ $t('accountUsdt.wechatQrcode') }}</div>
					<div class="qrcode_img">
						<van-uploader v-model="fileList" multiple :max-count="1" class="upload"
							:max-size="2 * 1024 * 1024" @oversize="onOversize" :after-read="afterRead"
							:before-read="beforeRead">
						</van-uploader>
					</div>
				</div>
			</div>
			<!-- 银行卡 -->
			<div v-show="type == 4">
				<div class="item">
					<div class="ari_font">{{ $t('accountUsdt.name') }}</div>
					<input class="card" type="text" v-model="bank.name" :placeholder="$t('accountUsdt.nameEmpty')" :readonly="id !== -1">
				</div>
				<div class="item">
					<div class="ari_font">{{ $t('accountUsdt.account') }}</div>
					<input class="card" type="text" v-model="bank.account" :readonly="id !== -1"
						:placeholder="$t('accountUsdt.accountEmpty')">
				</div>
				<!-- <div class="item">
					<div class="ari_font">{{ $t('accountUsdt.area') }}</div>
					<input class="card" type="text" v-model="bank.area" :placeholder="$t('accountUsdt.areaEmpty')">
				</div> -->
				<div style="height: 10px;"></div>
				<!-- <div class="item">
					<div class="ari_font">I F S C&nbsp;&nbsp; ：</div>
					<input class="card" type="text" v-model="bank.mobile" :placeholder="$t('accountUsdt.mobileEmpty')">
				</div> -->
			</div>
		</div>
		<div class="basic_btn" v-if="id === -1" @click="submitBtn">{{ $t('account.submit') }}</div>
	</div>
</template>

<script>
import Vue from 'vue';
import Fetch from '../../utils/fetch'
import Api from "../../interface/index";
import {
	Overlay, Uploader, Button, DropdownMenu, DropdownItem, Toast, Dialog
} from 'vant';
import axios from 'axios'

Vue.use(Overlay).use(Uploader).use(Button).use(DropdownMenu).use(DropdownItem);
export default {
	name: "addcountUsdt",
	data() {
		return {
			bank: {
				account: '',
				name: '',
				area: '',
				bank: '',
				img: '',
				type: 1,
				wid: 0
			},
			fileList: [],
			type: 4,
			value: -1,
			wallets: [],
			id:0
		};
	},
	created() {
		this.$parent.footer('user', false);
	},
	mounted() {
		if (this.$route.query.id) {
			this.id = this.$route.query.id
		}else {
			this.id = -1
		}
		this.start();
	},
	methods: {
		start() {
			Fetch('/user/wallet_type', {
			}).then(r => {
				this.bank.bank = r.data[0].name;
				this.bank.type = r.data[0].type;
				this.type = r.data[0].type;
				this.bank.wid = r.data[0].id;
				for (let i = 0; i < r.data.length; i++) {
					this.wallets.push({
						text: r.data[i].name,
						value: i,
						type: r.data[i].type,
						wid: r.data[i].id
					})
				}
				if(this.id !== -1) {
					Fetch('/user/my_bank').then((rs) => {
						if (rs.code == 1) {
							if (rs.data.bank.length > 0) {
								let i = rs.data.bank.findIndex(x => x.id == this.id)
								this.value = this.wallets.findIndex(x => x.text == rs.data.bank[i].bank)
								
								this.$set(this.bank, 'name', rs.data.bank[i].user)
								this.$set(this.bank, 'bank', rs.data.bank[i].bank)
								this.$set(this.bank, 'account', rs.data.bank[i].account)
								this.$set(this.bank, 'type', rs.data.bank[i].type)
							}
						} else {
							this.bank = {
								account: '',
								name: '',
								area: '',
								bank: '',
								img: '',
								type: 1,
								wid: 0
							}
							this.value = 0
							this.$toast(r.msg)
						}
					});
				}else {
					this.value = 0
				}
			})
		},
		submitBtn() {
			// if (!this.bank.card) {
			//     this.$notify(this.$t('account.addressEmpty'));
			//     return;
			// }
			// if (!this.bank.img) {
			//     this.$notify(this.$t('account.qrcodeEmpty'));
			//     return;
			// }
			Fetch('/user/bank_add', {
				...this.bank
			}).then(r => {
				if (r.code == 1) {
					Toast(r.info)
					setTimeout(() => {
						this.$router.go(-1)
					}, 500);
				} else {
					Toast(r.msg)
				}
			})
		},
		onOversize(file) {
			this.$toast(this.$t('account.within2megabytes'));
		},
		beforeRead(file) {
			if (file.type !== 'image/jpeg' && file.type !== 'image/jpg' && file.type !== 'image/png') {
				this.$toast(this.$t('account.supportPicture'));
				return false;
			}
			return true;
		},
		afterRead(file) {
			let formData = new FormData();
			formData.append('language', this.$i18n.locale || "zh_cn");
			formData.append('file', file.file);
			formData.append('id', this.$router.history.current.params.id);
			formData.append('token', localStorage.getItem('token'));
			Toast.loading({
				forbidClick: true,
				duration: 20000
			});
			axios.post(Api.commonUrl + "/api/index/bank_link_upload", formData).then((r) => {
				Toast.clear();
				if (r.data.code === 1) {
					this.bank.img = r.data.data;
				} else {
					if (r.data.info) {
						this.$toast(r.data.info);
					} else {
						this.$toast(this.$t('account.uploadFail'));
					}
				}
			});
		},
		onChange() {
			// console.log(this.value)
			this.type = this.wallets[this.value]['type'];
			this.bank.bank = this.wallets[this.value]['text'];
			this.bank.type = this.wallets[this.value]['type'];
			this.bank.wid = this.wallets[this.value]['wid'];
			console.log(this.wallets)
		}

	}
};
</script>

<style lang="less" scoped>
// /deep/ .van-overlay{
// 	background-color:hsla(0,0%,100%,0);
// }
//    /deep/ .van-dropdown-menu {
//        position: relative;
// 	width: 100%;
//        z-index: 10;
//        color: #CCCCCC;
//    }

/deep/ .van-dropdown-menu__bar {
	box-shadow: none;
	width: 200px;
	height: 40px;
	background: none;
	// position: relative;
	// z-index: 10;
	// height: 34px;
	// border: 1px solid #D9D9D9;
	// border-radius: 4px;
	// text-align: left;
}

/deep/ .van-dropdown-menu__title {
	color: #fff;
}

//    /deep/ .van-dropdown-item--down {
//        margin: 0 auto;
//        z-index: 12;
//        transform: translateX(4px);
//    }

/deep/ .van-dropdown-menu__item {
	justify-content: flex-start;
}

//    /deep/ .van-dropdown-menu__title {
//        width: 100%;
//    }

//    /deep/ .van-dropdown-menu__title::after {
//        width: 13px;
//        height: 22px;
//        transform: none;
//        background: url(../../assets/images/drop.png) no-repeat center center;
//        background-size: 100% 100%;
//        border: none;
//        opacity: 1;
//        margin-top: -11px;
//        right: 10px;
//    }

//    /deep/ .van-cell {
//        padding: 5px 8px;
//    }

//    /deep/ .van-cell__title {
//        flex: 3;
//        white-space: normal;
//    }

//    /deep/ .van-ellipsis {
//        color: #000;
//    }

//    /deep/ .van-dropdown-item__option {
//        color: #ccc;
//        border: 1px solid #D9D9D9;
//        border-bottom: none;
//        border-radius: 4px;
//    }

//    /deep/ .van-dropdown-item__option:last-child {
//        border-bottom: 1px solid #D9D9D9;
//    }

//    /deep/ .van-dropdown-item__option--active.van-dropdown-item__option {
//        color: #000;

//        .van-dropdown-item__icon {
//            color: #E96259;
//        }
//    }
/deep/ .van-button--primary {
	background-color: transparent;
	border: none;
	width: 100%;
	height: 100%;
}

/deep/ .van-popup--top {
	max-width: 750px;

}

/deep/ .van-uploader__input-wrapper {
	width: 100%;
}

/deep/ .van-uploader__wrapper {
	width: 100%;
	height: 100%;
}

/deep/ .van-uploader__upload {
	width: 100%;
	height: 100%;
	margin: 0;
}

/deep/ .van-uploader__preview {
	margin: 0;
}

/deep/ .van-uploader__preview-image {
	width: 100%;
	height: 100%;
}

.back_left {
	background: url(../../views/images/item/back_b.png) no-repeat center center;
}

.big_tit {
	color: #000000;
}

.rela {
	position: relative;
	z-index: 11;
}

.warp1 {
	margin-top: 12px;

	.item {
		height: 42px;
		padding: 0 16px;
		font-size: 14px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		border-radius: 10px;
		margin: 10px auto;
		border: 1px solid rgb(186, 192, 198);
		background: linear-gradient(90deg, rgb(20, 40, 52) 0%, rgb(26, 48, 49) 100%);


		&:last-child {
			border-bottom: none;
		}

		.card {
			width: 100%;
		}

		input {
			line-height: 14px;
			padding: 0 8px;
			color: #fff;
		}
	}
}

::v-deep .van-popup--top {
	width: 92%;
	border-radius: 10px;
	border: 1px solid #375852;

	.van-cell {
		background: #0e3f33;
		color: #fff;
	}

	.van-dropdown-item__option--active,
	.van-dropdown-item__option--active .van-dropdown-item__icon {
		color: #cad80b;
	}
}

.ari_font {
	word-break: keep-all;
	white-space: nowrap;
	height: 20px;
	font-size: 14px;
	font-weight: 600;
	color: #E6F7EF;
	line-height: 20px;
	margin-right: 5px;
}

.basic_btn {
	margin: 75px auto 0 auto;
}

.qrcode {
	padding-top: 30px;
	padding-bottom: 30px;
	text-align: center;

	div {
		color: #999;
		font-size: 14px;
		margin-bottom: 20px;
	}

	.upload {
		width: 100%;
		height: 100%;
	}

	.qrcode_img {
		width: 250px;
		height: 250px;
		margin: 0 auto;
		background: linear-gradient(to left, #999, #999) left top no-repeat,
			linear-gradient(to bottom, #999, #999) left top no-repeat,
			linear-gradient(to left, #999, #999) right top no-repeat,
			linear-gradient(to bottom, #999, #999) right top no-repeat,
			linear-gradient(to left, #999, #999) left bottom no-repeat,
			linear-gradient(to bottom, #999, #999) left bottom no-repeat,
			linear-gradient(to left, #999, #999) right bottom no-repeat,
			linear-gradient(to left, #999, #999) right bottom no-repeat;
		background-size: 1px 20px, 20px 1px, 1px 20px, 20px 1px;

		span {
			line-height: 220px;
		}

		img {
			width: 240px;
			height: 240px;
			position: relative;
			top: -255px;
		}
	}
}

.recharge_wrap {
	background-image: linear-gradient(90deg, #0d3a32, #082820 55%, #051a15);
	min-height: 100dvh;
}

.wrap_box {
	width: 92%;
	background: none;
	margin: 20px auto 0px auto;
	padding-bottom: 10px;
	box-shadow: none;
}

.title-box {
	width: 100%;
	display: flex;
	align-items: center;
	padding: 15px;
	height: 60px;
	position: sticky;
	top: 0px;
	z-index: 10;
	background: #072B22;
	border-bottom: 1px solid #265245;

	h2 {
		color: #E6F7EF;
		margin-left: 10px;
	}

	.btn,
	.back {
		height: 32px;
		display: flex;
		align-items: center;
		justify-content: center;
		border: 1px solid #375852;
		border-radius: 12px;
		padding: 8px 9px;
		color: #fff;
		margin-left: auto;
		background: none;

		.iconfont {
			font-size: 18px;
		}
	}

	.back {
		margin-left: 0px;
	}
}
</style>
